import { ContentBox } from "@msuite/ui/app-shell";
import { DataTable } from "@msuite/ui/table";
import { useOrderTemplates } from "@/hooks/use-order-templates";
import { OrderTemplatesMenu } from "./order-templates-menu";
import { columns } from "./table-config";

export function OrderTemplates() {
	const { data: orderTemplates, isLoading, queryKey, refetch } = useOrderTemplates();

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={orderTemplates}
				columns={columns}
				isLoading={isLoading}
				refetch={refetch}
				queryKey={queryKey}
				persistenceKey="data-order-templates-table"
				menu={<OrderTemplatesMenu />}
				getRowCanExpand={() => true}
			/>
		</ContentBox>
	);
}
